import React, { Component } from "react";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import ExpHelper from "../../../../../Common/Helpers/ExpHelper";

export default class LimiteFinanciacionNuevo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            LimiteFinanciacionDesde: props.data.LimiteFinanciacionDesde,
            LimiteFinanciacionHasta: props.data.LimiteFinanciacionHasta,
            LimiteFinanciacionDefault: props.data.LimiteFinanciacionDefault,
            LimiteFinanciacionErrorMaximoMinimo: false,
            LimiteFinanciacionErrorDefault:false,
            
        };
    }

    onLimiteFinanciacionChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        /*Antes de actualizar cualquier cosa, valido que se haya presionado el boton*/
        if (this.props.data.LimiteFinanciacionxCuenta) {

            if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
                let newState = {
                    [dataset.code]: value
                }

                if (dataset.code == "LimiteFinanciacionDesde") {
                    newState = {
                        ...newState,
                        LimiteFinanciacionDefault: value
                    }
                }

                this.setState(newState);
            }
        }
    }

    onLimiteFinanciacionBlur(event) {
        const { value, dataset } = event.target;
        if(dataset.code =="LimiteFinanciacionDesde"&&this.state.LimiteFinanciacionHasta!== ""){
            if(value>this.state.LimiteFinanciacionHasta){
                this.setState({
                    LimiteFinanciacionErrorMaximoMinimo:true,
                    LimiteFinanciacionErrorDefault:false,
                })
                this.props.changeInput("LimiteFinanciacionDefault", value);
            }
        }
        if(dataset.code =="LimiteFinanciacionHasta"){
            if(value<this.state.LimiteFinanciacionDesde){
                this.setState({
                    LimiteFinanciacionErrorMaximoMinimo:true,
                    LimiteFinanciacionErrorDefault:false,
                })
            }

        }
        if(dataset.code == "LimiteFinanciacionDefault"){
            if(parseInt(value)<this.state.LimiteFinanciacionDesde || parseInt(value)>this.state.LimiteFinanciacionHasta){
                this.setState({
                    LimiteFinanciacionErrorDefault:true,
                    LimiteFinanciacionErrorMaximoMinimo:false,
                })
            }
        }
        if(value==""){
            this.setState({
                LimiteFinanciacionErrorDefault:false,
                LimiteFinanciacionErrorMaximoMinimo:false,
            })
        }
        this.props.changeInput(dataset.code, value);       
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.data.LimiteFinanciacionxCuenta == false) {
            nextProps.data.LimiteFinanciacionDesde = nextProps.data.LimiteFinanciacionHasta = nextProps.data.LimiteFinanciacionDefault = "";
        }

        this.setState({
            LimiteFinanciacionDesde: nextProps.data.LimiteFinanciacionDesde,
            LimiteFinanciacionHasta: nextProps.data.LimiteFinanciacionHasta,
            LimiteFinanciacionDefault: nextProps.data.LimiteFinanciacionDefault,
        });
    }

    render() {
        const { onLimiteFinanciacionChange, onLimiteFinanciacionBlur } = this;
        let { data, selectCheckBox } = this.props;
            
        let acentoLetraIminuscula = ExpHelper.ConvertirCaracter("i");
        let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");

        if(!data.GET_PARAMETRO_GENERAL.SINOLIMITEFINANCIACIONCUENTA){
            return null
        }

        return (
            <div>
                <div className="row top-separator-xs">
                    <div className="col-xs-12">
                        <label className="label-primary">{"L" + acentoLetraIminuscula + "mite de Financiaci" + acentoLetraOminuscula + "n"}</label>
                        <CheckDefecto
                            nombre={"Establecer Por Cuenta"}
                            check={data.LimiteFinanciacionxCuenta}
                            referencia={"ESPORCUEN"}
                            selectCheckBox={(event) => selectCheckBox("LimiteFinanciacionxCuenta", event.target.checked)}
                        />
                        <div className="container-radio radio-margin">
                            <div className="row">
                                <div className="col-xs-3">
                                    <label className="lbl-radio label-secondary">{"Rango porcentual"}</label>
                                </div>

                                <div className="col-xs-2">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.LimiteFinanciacionDesde}
                                        data-code="LimiteFinanciacionDesde"
                                        data-validation="^([0-9]?\d|100)$"
                                        disabled={!data.LimiteFinanciacionxCuenta}
                                        onChange={onLimiteFinanciacionChange.bind(this)}
                                        onBlur={onLimiteFinanciacionBlur.bind(this)}
                                    />
                                </div>

                                <div className="col-xs-1">
                                    <label className="label-secondary">{"% a"}</label>
                                </div>

                                <div className="col-xs-2">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.LimiteFinanciacionHasta}
                                        data-code="LimiteFinanciacionHasta"
                                        data-validation="^([0-9]?\d|100)$"
                                        disabled={!data.LimiteFinanciacionxCuenta}
                                        onChange={onLimiteFinanciacionChange.bind(this)}
                                        onBlur={onLimiteFinanciacionBlur.bind(this)}
                                    />
                                </div>
                                <div className="col-xs-1"><label>%</label></div>
                            </div>

                            <div className="row">
                                <div className="col-xs-3">
                                    <label className="lbl-radio label-secondary">{"Porcentaje por defecto"}</label>
                                </div>

                                <div className="col-xs-2">
                                    <input className="form-control input-Short"
                                        maxLength={3}
                                        value={this.state.LimiteFinanciacionDefault}
                                        data-code="LimiteFinanciacionDefault"
                                        data-validation="^([0-9]?\d|100)$"
                                        disabled={!data.LimiteFinanciacionxCuenta}
                                        onChange={onLimiteFinanciacionChange.bind(this)}
                                        onBlur={onLimiteFinanciacionBlur.bind(this)}
                                    />
                                </div>
                            </div>

                            {/*data.ERROR_PRODUCT["seleccionoLimiteFinanciacion"] == false &&
                                <label className="error">{"Debe ingresar rango de coeficiente v�lido."}</label>*/}
                            {data.LimiteFinanciacionxCuenta && <div className="lbl-radio">
                                <CheckDefecto
                                    check={data.LimiteFinanciacionDefaultInterfaz}
                                    referencia={"ESPORCUENDEFAULT"}
                                    selectCheckBox={(event) => selectCheckBox("LimiteFinanciacionDefaultInterfaz", event.target.checked)}
                                    />
                            </div>}
                        </div>
                         {(!data.ERROR_PRODUCT["seleccionoLimiteFinanciacion"]&&this.state.LimiteFinanciacionErrorMaximoMinimo) &&
                        <label className="error">{"El límite inferior debe ser menor o igual al límite superior"}</label>}
                         {(!data.ERROR_PRODUCT["seleccionoLimiteFinanciacion"] && this.state.LimiteFinanciacionErrorDefault) &&
                        <label className="error">{"El valor por defecto debe estar entre el límite inferior y superior"}</label>}
                         {(!data.ERROR_PRODUCT["seleccionoLimiteFinanciacion"]&&(!this.state.LimiteFinanciacionErrorMaximoMinimo&&!this.state.LimiteFinanciacionErrorDefault) ) &&
                        <label className="error">{"Debe ingresar un límite de financiación"}</label>}
                    </div>

                </div>
            </div>
        );
    }
}